import { render, staticRenderFns } from "./NewOrdersTree.vue?vue&type=template&id=9d7d865e&scoped=true"
import script from "./NewOrdersTree.vue?vue&type=script&lang=js"
export * from "./NewOrdersTree.vue?vue&type=script&lang=js"
import style0 from "./NewOrdersTree.vue?vue&type=style&index=0&id=9d7d865e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d7d865e",
  null
  
)

export default component.exports